import { get } from '@api/api';
import { IFeatureFlag } from '@api/featureFlags/types/IFeatureFlags';

export function getFeatureFlagsAndEnablers() {
  return get<IFeatureFlag[]>(`/feature-flags`);
}
